<!-- 监测指标数据跟踪 -->
<template>
  <div class="container">
    <div class="btn-box">
       <!-- 加一个文本框 -->
      <el-input v-model="currentTime" placeholder="请输入时间" style="width: 200px;margin-right: 10px;"/>
      <el-button type="primary" @click="updateData">更新数据</el-button>
      <el-button type="primary" @click="contrastSituation">应用情况近两月对比</el-button>
    </div>
    <div class="table-box">
      <table v-if="detailData.declBuildBaseInfo">
        <tr class="tr-head">
          <td colspan="3">一、资源库基本信息</td>
        </tr>
        <tr>
          <td>当前级别</td>
          <td colspan="2">{{ detailData.declBuildBaseInfo.projectType }}</td>
        </tr>
        <tr>
          <td>上线时长（学期）</td>
          <td colspan="2">
            {{ detailData.declBuildBaseInfo.standardCourseTime }}
          </td>
        </tr>
        <tr>
          <td>接入国家职业教育智慧教育平台</td>
          <td colspan="2">
            {{ detailData.joinCountryPlatform }}
            <!-- <el-radio-group v-model="detailData.joinCountryPlatform">
            <el-radio label="是">是</el-radio>
            <el-radio label="否">否</el-radio>
          </el-radio-group> -->
          </td>
        </tr>
        <tr class="tr-head">
          <td colspan="3">二、资源建设与应用情况</td>
        </tr>
        <tr>
          <td>资源总量</td>
          <td colspan="2">{{ detailData.resourceBuild.resourceCount }}</td>
        </tr>
        <tr>
          <td>文本类/图形图像</td>
          <td>{{ detailData.resourceBuild.textVo.sumValue }}</td>
          <td>{{ detailData.resourceBuild.textVo.percentage }}</td>
        </tr>
        <tr>
          <td>文本型演示文稿（ppt、网页课件与富媒体等）</td>
          <td>{{ detailData.resourceBuild.textPPTVo.sumValue }}</td>
          <td>{{ detailData.resourceBuild.textPPTVo.percentage }}</td>
        </tr>
        <tr>
          <td>动画类</td>
          <td>{{ detailData.resourceBuild.animationVo.sumValue }}</td>
          <td>{{ detailData.resourceBuild.animationVo.percentage }}</td>
        </tr>
        <tr>
          <td>虚拟仿真类</td>
          <td>{{ detailData.resourceBuild.virtualVo.sumValue }}</td>
          <td>{{ detailData.resourceBuild.virtualVo.percentage }}</td>
        </tr>
        <tr>
          <td>音频类</td>
          <td>{{ detailData.resourceBuild.audioVo.sumValue }}</td>
          <td>{{ detailData.resourceBuild.audioVo.percentage }}</td>
        </tr>
        <tr>
          <td>视频类</td>
          <td>{{ detailData.resourceBuild.videoVo.sumValue }}</td>
          <td>{{ detailData.resourceBuild.videoVo.percentage }}</td>
        </tr>
        <tr>
          <td>微课类</td>
          <td>{{ detailData.resourceBuild.smallCourseVo.sumValue }}</td>
          <td>{{ detailData.resourceBuild.smallCourseVo.percentage }}</td>
        </tr>
        <tr>
          <td>其他</td>
          <td>{{ detailData.resourceBuild.otherVo.sumValue }}</td>
          <td>{{ detailData.resourceBuild.otherVo.percentage }}</td>
        </tr>
        <tr>
          <td>原创资源占比</td>
          <td colspan="2">
            {{ detailData.resourceBuild.originVo.percentage }}
          </td>
        </tr>
        <tr>
          <td>资源被课程引用的占比</td>
          <td colspan="2">
            {{ detailData.resourceBuild.courseResourceVo.percentage }}
          </td>
        </tr>
        <tr>
          <td>资源内容存储总量（GB）</td>
          <td colspan="2">{{ detailData.declBuildBaseInfo.resourceSave }}</td>
        </tr>
        <tr>
          <td>文本型演示文稿、图形（像）类和文本类资源量（GB）</td>
          <td colspan="2">{{ detailData.declBuildBaseInfo.textImage }}</td>
        </tr>
        <tr>
          <td>专业人才培养方案（份）</td>
          <td colspan="2">
            {{ detailData.professionTrain }}
            <!-- <el-input v-model="detailData.professionTrain" placeholder="请输入" size="small" /> -->
          </td>
        </tr>
        <tr>
          <td>标准化课程的知识图谱（份）</td>
          <td colspan="2">
            {{ detailData.standardCourseAtlas }}
            <!-- <el-input v-model="detailData.standardCourseAtlas" placeholder="请输入" size="small" /> -->
          </td>
        </tr>
        <tr>
          <td>课程教学标准或规范（份）</td>
          <td colspan="2">
            {{ detailData.courseTeachStandard }}
            <!-- <el-input v-model="detailData.courseTeachStandard" placeholder="请输入" size="small" /> -->
          </td>
        </tr>
        <tr>
          <td>资源访问总量</td>
          <td colspan="2">{{ detailData.resourceBuild.resourceVisit }}</td>
        </tr>
        <tr>
          <td>无活动资源数</td>
          <td colspan="2">{{ detailData.resourceBuild.noActiveResource }}</td>
        </tr>
        <tr class="tr-head">
          <td colspan="3">三、课程建设与应用情况</td>
        </tr>
        <tr>
          <td>课程总数（门）</td>
          <td colspan="2">
            {{
              +detailData.declBuildBaseInfo.standardNum +
              +detailData.declBuildBaseInfo.majorCoreNum
            }}
          </td>
        </tr>
        <tr>
          <td>标准化课程（门）</td>
          <td colspan="2">{{ detailData.declBuildBaseInfo.standardNum }}</td>
        </tr>
        <tr>
          <td>专业核心课程（门）</td>
          <td colspan="2">
            {{ detailData.declBuildBaseInfo.majorCoreNum }}
            <!-- <el-input v-model="detailData.declBuildBaseInfo.majorCoreNum" placeholder="请输入" size="small" /> -->
          </td>
        </tr>
        <tr>
          <td>标准化课程选课总人数（人）</td>
          <td colspan="2">{{ detailData.standardCourseRegNum }}</td>
        </tr>
        <tr>
          <td>无访问标准化课程数（门）</td>
          <td colspan="2">{{ detailData.noActiveStandardNum }}</td>
        </tr>
        <tr class="tr-head">
          <td colspan="3">四、题库建设与应用情况</td>
        </tr>
        <tr>
          <td>题库总数</td>
          <td colspan="2">{{ detailData.questionCount }}</td>
        </tr>
        <tr>
          <td>主观题</td>
          <td colspan="2">{{ detailData.objectiveQ }}</td>
        </tr>
        <tr>
          <td>客观题</td>
          <td colspan="2">{{ detailData.subjectivityQ }}</td>
        </tr>
        <tr>
          <td>题库使用率（%）</td>
          <td colspan="2">
            {{ detailData.declBuildBaseInfo.questionBankUseRate }}
          </td>
        </tr>
        <tr class="tr-head">
          <td colspan="3">五、整体应用推广情况</td>
        </tr>
        <tr>
          <td>访问总量（次）</td>
          <td colspan="2">{{ detailData.userVisitNum }}</td>
        </tr>
        <tr>
          <td>用户总数（人）</td>
          <td colspan="2">{{ userTotal }}</td>
        </tr>
        <tr v-for="(item, index) in userTypeArr" :key="index">
          <td>{{ item.name }}总数（人）</td>
          <td colspan="2">{{ item.value }}</td>
        </tr>
        <tr>
          <td>主持单位核心专业与服务专业教师合计人数（人）</td>
          <td colspan="2">
            {{ detailData.declBuildBaseInfo.chargeCoreTeacher }}
          </td>
        </tr>
        <tr>
          <td>其中：实名注册合计人数（人）</td>
          <td colspan="2">
            {{ detailData.declBuildBaseInfo.chargeCoreRealNameTeacher }}
          </td>
        </tr>
        <tr>
          <td>其中：实名注册无活动人数（人）</td>
          <td colspan="2">{{ detailData.chargeNoAccessTeacher }}</td>
        </tr>
        <tr>
          <td>主持单位核心专业与服务专业学生合计人数（人）</td>
          <td colspan="2">
            {{ detailData.declBuildBaseInfo.chargeCoreStudent }}
          </td>
        </tr>
        <tr>
          <td>其中：实名注册合计人数（人）</td>
          <td colspan="2">
            {{ detailData.declBuildBaseInfo.chargeCoreRealNameStudent }}
          </td>
        </tr>
        <tr>
          <td>其中：实名注册无活动人数（人）</td>
          <td colspan="2">{{ detailData.chargeNoAccessStudent }}</td>
        </tr>
        <tr>
          <td>参与单位核心专业与服务专业教师合计人数（人）</td>
          <td colspan="2">
            {{ detailData.declBuildBaseInfo.pitchCoreTeacher }}
          </td>
        </tr>
        <tr>
          <td>其中：实名注册合计人数（人）</td>
          <td colspan="2">
            {{ detailData.declBuildBaseInfo.pitchRealNameTeacher }}
          </td>
        </tr>
        <tr>
          <td>其中：实名注册无活动人数（人）</td>
          <td colspan="2">{{ detailData.buildSchoolNoAccessTeacher }}</td>
        </tr>
        <tr>
          <td>参与单位核心专业与服务专业学生合计人数（人）</td>
          <td colspan="2">
            {{ detailData.declBuildBaseInfo.pitchCoreStudent }}
          </td>
        </tr>
        <tr>
          <td>其中：实名注册合计人数（人）</td>
          <td colspan="2">
            {{ detailData.declBuildBaseInfo.pitchRealNameStudent }}
          </td>
        </tr>
        <tr>
          <td>其中：实名注册无活动人数（人）</td>
          <td colspan="2">{{ detailData.buildSchoolNoAccessTeacher }}</td>
        </tr>
        <tr class="tr-head">
          <td colspan="3">六、年度更新情况</td>
        </tr>
        <tr>
          <td>本年度新增资源数（条）</td>
          <td colspan="2">
            {{
              detailData.yearResourceAdd[detailData.yearResourceAdd.length - 1]
                .num
            }}
          </td>
        </tr>
        <tr>
          <td>本年度资源更新率</td>
          <td colspan="2">
            {{
              detailData.yearUpdateRate[detailData.yearUpdateRate.length - 1]
                .num
            }}
          </td>
        </tr>
        <tr>
          <td>本年度资源内容存储增量（GB）</td>
          <td colspan="2">{{ detailData.yearResourceSpaceAddNum }}</td>
        </tr>
        <tr>
          <td>本年度新增用户数（人）</td>
          <td colspan="2">
            {{ +detailData.yearTeacherAdd + +detailData.yearStudentAdd }}
          </td>
        </tr>
        <tr>
          <td>其中：新增教师数（人）</td>
          <td colspan="2">{{ detailData.yearTeacherAdd }}</td>
        </tr>
        <tr>
          <td>其中：新增学生数（人）</td>
          <td colspan="2">{{ detailData.yearStudentAdd }}</td>
        </tr>
        <tr>
          <td>本年度新增用户占比</td>
          <td colspan="2">{{ detailData.thisYearAddPercentage }}</td>
        </tr>
      </table>
    </div>
    <!-- 加载组件 -->
    <loading class="loading_box" v-if="$store.state.loading" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      zykId: "",
      detailData: {},
      userTypeArr: [], //整体应用推广情况用户类别
      userTotal: 0, //整体应用推广情况用户总数
      currentTime: "",
    };
  },
  mounted() {
    this.zykId = sessionStorage.getItem("zykId");
    this.getCurrentDate();
    this.getDeclBuildBaseInfo(this.currentTime);
  },
  methods: {
    // 更新数据
    updateData() {
      this.$store.commit("isLoading", true);
      this.$axios
        .post(this.$apiurls.initDeclBuildBaseInfo, {
          zykid: this.zykId,
          endTime: this.currentTime,
          loading: false,
        })
        .then((res) => {
          if (res.data) this.getDeclBuildBaseInfo(this.currentTime)
          this.$store.commit("isLoading", false);
        }).catch(() => {
          this.$store.commit("isLoading", false);
        });
    },
    contrastSituation() {
      this.$router.push("/contrastSituation");
    },
    // 获取表格数据
    getDeclBuildBaseInfo(time) {
      //获取当前时间
      this.$axios
        .post(this.$apiurls.getDeclBuildBaseInfo, {
          zykId: this.zykId,
          endTime: time,
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            this.detailData = res.data;
            this.userTypeArr = res.data.userTypeNum.filter(
              (item) => item.name !== "其他"
            );
            let sum = 0;
            this.userTypeArr.forEach((item) => {
              sum += item.value;
            });
            this.userTotal = sum;
          }
        });
    },

    // 点击保存按钮
    getTableData() {
      let data = {
        dataMap: this.detailData,
        zykid: this.zykId,
      };
      this.$axios
        .post(this.$apiurls.saveDeclBuildBaseInfo, data, { loading: false })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "保存成功！",
              type: "success",
            });
            this.getDeclBuildBaseInfo();
          }
        });
    },

    getCurrentDate() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let day = date.getDate();
      day = day < 10 ? "0" + day : day;
      this.currentTime = `${year}-${month}-${day}`;
    },

    // 点击导出按钮
    exportBuildBaseInfo() {
      // this.$router.push("/exportMonitorIndexDataTrack")
      let routeUrl = this.$router.resolve({
        path: "/exportMonitorIndexDataTrack",
        query: {
          zykId: this.zykId,
          zykName: sessionStorage.getItem("zykName"),
          token: sessionStorage.getItem("lrmv2token"),
          zykNum: sessionStorage.getItem("zykNum"),
          time: this.currentTime,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    // 导出Excel
    exportBuildBaseManageInfo() {
      this.$axios
        .get(
          `${this.$apiurls.exportBuildBaseManageInfo
          }?zykId=${sessionStorage.getItem("zykId")}`,
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.code === 200) {
            window.open(res.data);
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  height: 100%;

  .btn-box {
    text-align: right;
    margin-bottom: 20px;

    .el-button {
      height: 32px;
      line-height: 32px;
      padding: 0 20px;
    }
  }

  .table-box {
    height: calc(100% - 52px);
    color: #fff;
    overflow: auto;

    table {
      width: 100%;
      margin-bottom: 1px;
      table-layout: fixed;
      border-collapse: collapse;

      tr {
        background-color: rgb(35, 42, 67);

        &:hover {
          transition: all 0.3s;
          background-color: rgba(31, 50, 94, 0.8);
        }

        td {
          height: 38px;
          padding-left: 30px;
          text-align: center;
          border: 1px solid #39456e;

          ::v-deep .el-input__inner {
            height: 28px;
            width: 200px;
            background: rgba(86, 94, 121, 0.59);
            border-color: rgba(86, 94, 121, 0.59);
            color: #e6a23c;
          }
        }
      }

      .tr-head {
        font-weight: bold;
        background-color: rgba(31, 50, 94, 0.8);

        td:first-child {
          text-align: left;
        }
      }
    }
  }
}
</style>
